import { Component } from '@angular/core';

@Component({
  selector: 'ncp-invalid-path-error',
  imports: [],
  templateUrl: './invalid-path-error.component.html',
  styleUrl: './invalid-path-error.component.scss',
})
export class InvalidPathErrorComponent {}
